import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../shared/services/auth.service";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(private http: HttpClient, private authService : AuthService) { }

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
  }

  getSymbols() : Observable<any>
  {
    return this.http.get(`${environment.apiUrl}/symbol`);
  }

  getNetworks() : Observable<any>
  {
    return this.http.get(`${environment.apiUrl}/redesmoedas`);
  }

  getWallets() : Observable<any>
  {
    return this.http.get(`${environment.apiUrl}/wallet`);
  }

  getEnabledWallets(symbolId: string) : Observable<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("symbolId", symbolId);
    return this.http.get(`${environment.apiUrl}/wallet/enabled`,{params: queryParams});
  }

  enableDisableWallet(wallet: any){
    return this.http.post(`${environment.apiUrl}/wallet/enable`,wallet);
  }
  add(wallet: any){
    return this.http.post(`${environment.apiUrl}/wallet`,wallet);
  }
}
